// Script entry for the prerendered site pages (vite.config.ts, scripts/prerender.mjs).
import { enhanceSite } from "./enhance";

enhanceSite(document);
